export default __webpack_public_path__ + "static/media/restaurant.0b579403.png";